import { api } from "@/comn";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { TFormSchema, TGridSchema, useFetch } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";

/*
 * Survey Management Service
 * !== 설문 관리 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */

export const BASE = {
    path: `${ptlEnvs.base}/surv/qustnr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/surv/qustnr`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0418001q: `${BASE.path}/ptli0418001q`, //
    ptli0418002s: `${BASE.path}/ptli0418002s`, //
    ptli0418003s: `${BASE.path}/ptli0418003s`, //
    ptli0418004q: `${BASE.path}/ptli0418004q`, //
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getSurvMgmtList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    createSurv: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    getSurvInfo: (id: any) => {
        return api.get(`${BASE.api}/${id}`);
    },
    updateSurvInfo: (data: any) => {
        return api.put(`${BASE.api}/${data.qestnrId}`, { ...data });
    },

    deleteSurvInfo: (qestnrId: any) => {
        return api.delete(`${BASE.api}/${qestnrId}`);
    },

    updateSurvActv: (data: any) => api.put(`${BASE.api}/actv/${data.qestnrId}`, { ...data }),

    updateSurvInactv: (data: any) => api.put(`${BASE.api}/inactv/${data.qestnrId}`, { ...data }),
};

export const SF_SURV_MGMT_LIST_SRCH: TFormSchema = {
    id: "form_SurvMgmtListSrch",
    schema: {
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
            required: true,
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
            editType: "both",
        },
        qustnrTtle: { type: "text", label: "L_QUSTNR_TTLE" },
        rgsrUsr: { type: "text", label: "L_RGSR_USR" },
        reqDateRnge: {
            type: "daterange",
            label: "L_RQST_DT",
            start: { name: "qustnrStrtDt" },
            end: { name: "qustnrEndDt" },
            rangeButton: 4,
        },
    },
};

// usrStatCd: { type: "select", label: "L_USR_STAT", area: "comnCd", comnCd: "PTL0001", required: true },
// delYn: { type: "radio", label: "L_DEL_YN" },

export const SF_SURV_INFO: TFormSchema = {
    id: "form_survInfo",
    schema: {
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
            required: true,
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
            editType: "both",
        },
        mnPgeQustnrYn: {
            type: "radio",
            label: "L_MN_PGE_QUSTNR_YN",
            required: true,
            area: "comnCd",
            comnCd: "PTL0062",
            defaultValue: "Y",
        },

        qustnrTtleKO: { type: "text", label: "L_QUSTNR_TTLE_KO", required: true },
        qustnrTtleEN: { type: "text", label: "L_QUSTNR_TTLE_EN", required: true },
        qustnrTtleTZ: { type: "text", label: "L_QUSTNR_TTLE_TZ", required: true },

        qustnrPupsCnKO: { type: "text", label: "L_QUSTNR_PUPS_CN_KO", required: true },
        qustnrPupsCnEN: { type: "text", label: "L_QUSTNR_PUPS_CN_EN", required: true },
        qustnrPupsCnTZ: { type: "text", label: "L_QUSTNR_PUPS_CN_TZ", required: true },

        qustnrMakeInfoCn: { type: "text", label: "L_QUSTNR_MAKE_INFO_CN" },

        qustnrTrgtAcrdtYn: {
            //type: "select",
            type: "radio",
            label: "L_QUSTNR_TRGT_ACRDT_YN",
            area: "comnCd",
            comnCd: "PTL0063",
            // options: [
            //     { label: "User", value: "1" },
            //     { label: "non-User", value: "2" },
            // ],
            defaultValue: "1",
            required: true,
        },
        reqDateRnge: {
            type: "daterange",
            label: "L_RQST_DT",
            start: { name: "qustnrStrtDt", minDate: comnUtils.getDate(), required: "true" },
            end: { name: "qustnrEndDt", minDate: comnUtils.getDate(), required: "true" },
            required: true,
        },
    },
};

export const SG_SURV_MGMT_LIST: TGridSchema = {
    id: "grid_SurvMgmtList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_QUSTNR_TTLE", binding: "qustnrTtle", width: "*" }] },
        { cells: [{ header: "L_QUSTNR_STRT_DT", binding: "qustnrStrtDt", width: "9%" }] },
        { cells: [{ header: "L_QUSTNR_END_DT", binding: "qustnrEndDt", width: "9%" }] },
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "*" }], id: "bsopClsfCd" },
        { cells: [{ header: "L_PTL_TP_CD", binding: "ptlTpCdNm", width: "10%" }], id: "ptlTpCd" },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "*" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "10%" }] },
        { cells: [{ header: "L_ACTVT_YN", binding: "qustnrActvYn", width: "8%" }] },
    ],
    body: [
        { cells: [{ binding: "qustnrTtle", align: "left" }] },
        { cells: [{ binding: "qustnrStrtDt", align: "center" }] },
        { cells: [{ binding: "qustnrEndDt", align: "center" }] },
        { cells: [{ binding: "bsopClsfCdNm", align: "center" }] },
        { cells: [{ binding: "ptlTpCdNm", align: "center" }] },
        { cells: [{ binding: "frstRegstId", align: "center" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
        { cells: [{ binding: "qustnrActvYn", type: "text", align: "center" }] },
    ],
};

export const SG_SURV_INFO_LANG_LIST: TGridSchema = {
    id: "grid_SurvInfoLangList",
    head: [
        { cells: [{ binding: "langCd" }] },
        { cells: [{ binding: "qustnrTtle" }] },
        { cells: [{ binding: "qustnrPupsCn" }] },
    ],
    body: [
        { cells: [{ binding: "langCd" }] },
        { cells: [{ binding: "qustnrTtle" }] },
        { cells: [{ binding: "qustnrPupsCn" }] },
    ],
};
